// ****************************************************
// Log Entry Class

import { LogLevel } from '@core/enums/log-level.enum';

// ****************************************************
export class LogEntry {
  // Public Properties
  entryDate: Date = new Date();
  message = '';
  level: LogLevel = LogLevel.Debug;
  extraInfo: unknown[] = [];
  logWithDate = true;

  // **************
  // Public Methods
  // **************
  buildLogString(): string {
    let value = '';

    if (this.logWithDate) {
      value = `${new Date().toLocaleString()} - `;
    }
    value += `Type: ${LogLevel[this.level]}`;
    value += ` - Message: ${this.message}`;
    if (this.extraInfo.length) {
      value += ` - Extra Info: ${this.formatParams(this.extraInfo)}`;
    }

    return value;
  }

  // ***************
  // Private Methods
  // ***************
  private formatParams(params: unknown[]): string {
    return params
      .map((item) => {
        if (item instanceof Error) {
          return `${item.name}: ${item.message}${item.stack ? `\n${item.stack}` : ''}`;
        }
        if (typeof item === 'string') {
          return item;
        }
        try {
          return JSON.stringify(item) ?? String(item);
        } catch {
          return String(item);
        }
      })
      .join(',');
  }
}
